// import Main from './Containers/Main';
import MainClaude from './Containers/MainClaude';
import './Styles/index.scss';

function App() {
  return (
    <div className="app">
        <MainClaude />
    </div>
  );
}

export default App;
